import { render, staticRenderFns } from "./SuperTable.vue?vue&type=template&id=27b31c57"
import script from "./SuperTable.vue?vue&type=script&lang=js"
export * from "./SuperTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports